var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.7197C20.0375 28.7197 19.2138 28.3773 18.529 27.6925C17.8442 27.0076 17.5012 26.1834 17.5 25.2197C17.4988 24.2561 17.8418 23.4324 18.529 22.7487C19.2162 22.0651 20.0398 21.7221 21 21.7197C21.9602 21.7174 22.7844 22.0604 23.4727 22.7487C24.1611 23.4371 24.5035 24.2607 24.5 25.2197C24.4965 26.1787 24.1541 27.003 23.4727 27.6925C22.7914 28.382 21.9672 28.7244 21 28.7197ZM12.9062 12.9697H29.0938L32.5938 5.96973H9.40625L12.9062 12.9697ZM14.7 37.4697H27.3C29.925 37.4697 32.1562 36.5586 33.9937 34.7362C35.8312 32.9139 36.75 30.6751 36.75 28.0197C36.75 26.9114 36.5604 25.8322 36.1812 24.7822C35.8021 23.7322 35.2625 22.7843 34.5625 21.9385L30.0125 16.4697H11.9875L7.4375 21.9385C6.7375 22.7843 6.19792 23.7322 5.81875 24.7822C5.43958 25.8322 5.25 26.9114 5.25 28.0197C5.25 30.6739 6.16175 32.9127 7.98525 34.7362C9.80875 36.5597 12.047 37.4709 14.7 37.4697Z",
    fill: "#006EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures8);
export default __webpack_public_path__ + "static/media/features8.71354d82a1724a1f181764e069a45f04.svg";
export { ForwardRef as ReactComponent };